import * as e from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/PushPinSimple.es.js";
const o = e.forwardRef((i, m) => /* @__PURE__ */ e.createElement(r, { ref: m, ...i, weights: s }));
o.displayName = "PushPinSimpleIcon";
const a = o;
export {
  a as PushPinSimple,
  o as PushPinSimpleIcon
};
